import TemplateView from "../../TemplateView";

export default class BlockedListItem extends TemplateView {
    constructor($containerEl, subtitle, title) {
        super($containerEl);
        this.subtitle = subtitle;
        this.title = title;
    }

    templateHtml() {
        return "<div class='blockedListItem'>" +
               "  <div class='subtitle'><%-subtitle%></div>" +
               "  <div class='title'><%-title%></div>" +
               "</div>";
    }
}


// WEBPACK FOOTER //
// ./web/js/cptManagement/deleteConfirmationDialog/BlockedListItem.js